import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchToday, type TodaySnapshot } from '@/lib/api';

export function todayQueryKey(slug: string) {
  return ['today', slug] as const;
}

/**
 * useToday — pulls the GET /pwa/today snapshot for the current tenant.
 * 30s refetch interval keeps the hero/stat row + attention badge warm so the
 * in-app indicator stays close-to-live without push being required. The
 * 15s staleTime is half the refetch interval so background tab switches don't
 * trigger a duplicate fetch on focus.
 */
export function useToday(slug: string): UseQueryResult<TodaySnapshot> {
  return useQuery<TodaySnapshot>({
    queryKey: todayQueryKey(slug),
    queryFn: () => fetchToday(slug),
    enabled: Boolean(slug),
    staleTime: 15_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
